/**
 * A model class that holds information about a certain metadata configuration
 */
export class MetadataConfig {
  /**
   * A unique identifier
   */
  id: string;

  /**
   * The label used for display
   */
  label: string;

  /**
   * The namespace of the metadata
   */
  nameSpace: string;
}
